import { SelectInput, TextInput, required, useTranslate } from 'react-admin';
import { useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import { PARAMETER_VALUE_TYPE, parameterBooleanValueChoices } from '@/constants/ParameterValueTypes.js';
import { validateParameterValue } from '@/helpers/parameter/parameterValidation.js';

export const ParameterValueInput = ({ source = 'value', isRequired = true }) => {
    const translate = useTranslate();
    const type = useWatch({ name: 'type' });
    const validateValue = (value, allValues) => validateParameterValue(value, allValues, translate);
    const validate = isRequired ? [required(translate('common.validation.required')), validateValue] : [validateValue];

    if (type === PARAMETER_VALUE_TYPE.BOOLEAN) {
        return (
            <SelectInput
                source={source}
                label={translate('resources.parameter.fields.value')}
                choices={parameterBooleanValueChoices(translate)}
                format={value => {
                    if (value === true || value === 1 || value === '1' || value === 'true') {
                        return 'true';
                    }
                    if (value === false || value === 0 || value === '0' || value === 'false') {
                        return 'false';
                    }
                    return value;
                }}
                validate={validate}
                emptyValue=''
                fullWidth
            />
        );
    }

    return (
        <TextInput
            source={source}
            label={translate('resources.parameter.fields.value')}
            validate={validate}
            multiline={type === PARAMETER_VALUE_TYPE.STRING}
            fullWidth
        />
    );
};

ParameterValueInput.propTypes = {
    source: PropTypes.string,
    isRequired: PropTypes.bool,
};
